import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'
const TallyIntegrationSoftware = () => {
    // Dynamically generate the location from the current URL
    //const urlSegments = window.location.pathname.split('/');
    //const loc = urlSegments.length === 4 ? `in ${urlSegments[3].replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}` : '';

    //// Set meta tags dynamically
    //document.title = `Best Tally Integration Software ${loc} | ERP Systems | Business Management Solutions - Tejaxo Software`;
    //document.querySelector('meta[name="description"]').setAttribute('content', `Tejaxo Software is a High Rated Indian Tally Integration Software ${loc}, providing award-winning Enterprise Resource Planning (ERP) software for Tally Integration, business management solutions, services and support.`);
    //document.querySelector('meta[name="keywords"]').setAttribute('content', `Tejaxo Tally Integration Software ${loc}, Tejaxo Tally Integration Software`);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                    <div className="row">
                        <h1 className="mkdf-page-title entry-title">Tally Integration Software {state.condText}</h1>
                </div>
                <hr />
                <div className="row">
                    <div className="col-sm-12">
                        <p>Tejaxo�s Tally Integration is powerful accounting software. It is driven by technologies to simplify the day-to-day activities involved in the ERP. Our Tally integration provides a solution to all the problems that a ERP encounters. Our software helps you efficiently manage tasks such as enterprise management, accounting management, and many more.</p>
                        <ul className="list-group" style={{ width: '100%' }}>
                            <li className="list-group-item active"><strong>Notable features of Tejaxo�s Tally Integration are:</strong></li>
                            <li className="list-group-item">Easy integration with Tejaxo ERPallows you to access all the data.</li>
                            <li className="list-group-item">Helps you in Student-wise auto-posting in map ledger.</li>
                            <li className="list-group-item">One-click voucher creation.</li>
                            <li className="list-group-item">Easy migration of data.</li>
                            <li className="list-group-item">Compatible with tally version.</li>
                            <li className="list-group-item">Helps you in fee head wise auto-posting in map ledger.</li>
                        </ul>
                        <hr />
                        <ul className="list-group" style={{ width: '100%' }}>
                            <li className="list-group-item active"><strong>Benefits of Tejaxo�s Tally Integration are:</strong></li>
                            <li className="list-group-item">Accuracy in the data.</li>
                            <li className="list-group-item">No extra amount of entry.</li>
                            <li className="list-group-item">Saves cost and time.</li>
                            <li className="list-group-item">Efficient ERP management.</li>
                            <li className="list-group-item">User-friendly.</li>
                        </ul>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default TallyIntegrationSoftware;